<template>
    <site-layout>
        <div align="center">
            <img src="../assets/img/logo.png" class="site-logo container" alt=""/>
            <div class="has-text-white">Bringing AI to team collaboration</div><br/>
        </div>

        <base-message v-if="$route.query['reset'] !== undefined">
            <strong>Your password has been updated.</strong>
        </base-message>

        <base-backend-errors :data="error"/>

        <router-link
            :to="{name: 'reset_password_link'}"
            class="has-text-white is-pulled-right forgot">

            Forgot your password?
        </router-link>

        <div class="is-clearfix"></div>

        <base-input v-model="form.email" name="email" icon="fas fa-envelope"
                    validate="required|email" placeholder="Email"/>

        <base-input v-model="form.password" name="password" icon="fas fa-lock"
                    validate="required" placeholder="Password" type="password"/>

        <base-button
            @click="submit"
            :loading="loading"
            class="is-success is-fullwidth"
            icon="fas fa-check"
            text="Sign in"/>

        <base-button
            v-if="free_signup"
            :to="{name: 'signup'}"
            class="is-primary is-fullwidth"
            icon="fas fa-user-plus"
            text="Sign up"/>

        <subscribe class="subscribe"/>
    </site-layout>
</template>

<script>
import { mapState } from 'vuex';
import SiteLayout from '../components/layouts/SiteLayout.vue';
import Subscribe from '../components/subscribe/Subscribe.vue';

export default {
    name: 'Login',
    components: { Subscribe, SiteLayout },
    data() {
        return {
            form: { email: '', password: '' },
        };
    },
    computed: {
        ...mapState('configurations', ['free_signup']),
        ...mapState('signin', ['loading', 'error']),
    },
    methods: {
        submit() {
            this.$validator.validate().then((result) => {
                if (!result) return null;

                return this.$store.dispatch('signin/signin', this.form).then(() => {
                    this.$router.push({ name: 'spaces' });
                });
            });
        },
    },
};
</script>

<style scoped>
    .subscribe {margin-top: 20vh;}
    .forgot {margin-bottom: 0.3rem}
</style>
